export default __webpack_public_path__ + "static/media/call_icon.0e0eb1cc.svg";